module.exports = __webpack_public_path__ + "img/南方电网.f5907ea7.png";